import ApiService from '@/services/api.service';

const UserVoiceService = {
    getByID(id) {
        return ApiService.get(`/UserVoiceBreakdown/${id}`);
    },
    addUserVoiceBreakdown(data) {
        return ApiService.post(`/UserVoiceBreakdown/userVoiceBreakdown`, data)
    },
    listingCommands(parameter) {
        var param = {
            UserID: parameter.UserId,
            IsActive: parameter.IsActive,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber
        }

        const requestData = {
            method: 'get',
            url: '/UserVoiceCommands/',
            headers: {},
            params: param
        };
        return ApiService.customRequest(requestData);
    },
    createCommand(data) {
        return ApiService.post(`/UserVoiceCommands`, data)
    },
    updateCommand(id, data) {
        return ApiService.put(`/UserVoiceCommands/${id}`, data)
    },
    deleteCommand(id, userID) {
        return ApiService.delete(`/UserVoiceCommands/${userID}-${id}`)
    }
}

export default UserVoiceService;